export interface CompressionOptions {
  maxSizeMB?: number;
  useWebWorker?: boolean;
  initialQuality?: number;
  maxWidthOrHeight?: number;
}

let heic2any: any = null;
let imageCompression: any = null;

async function loadImageLibraries() {
  if (!heic2any) {
    const heic2anyModule = await import('heic2any');
    heic2any = heic2anyModule.default;
  }
  if (!imageCompression) {
    const imageCompressionModule = await import('browser-image-compression');
    imageCompression = imageCompressionModule.default;
  }
}

export async function compressImage(file: File, options: CompressionOptions = {}): Promise<File> {
  await loadImageLibraries();

  let fileToCompress = file;

  if (file.type === 'image/heic' || file.name.toLowerCase().endsWith('.heic')) {
    try {
      const convertedBlob = await heic2any({
        blob: file,
        toType: 'image/jpeg',
        quality: 0.9,
      });

      fileToCompress = new File(
        [convertedBlob as BlobPart],
        file.name.replace(/\.heic$/i, '.jpg'),
        { type: 'image/jpeg' }
      );
    } catch (error) {
      console.error('Error converting HEIC file:', error);
      throw error;
    }
  }

  const defaultOptions = {
    maxSizeMB: 0.5,
    useWebWorker: true,
    initialQuality: 0.9,
    maxWidthOrHeight: 800,
  };

  const compressionOptions = { ...defaultOptions, ...options };

  return imageCompression(fileToCompress, compressionOptions);
}

export { loadImageLibraries };
